import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UserProfileService } from '../profile.services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '@core/models/user.model';

@Component({
    selector   : 'app-profile-edit',
    templateUrl: './profile-edit.component.html',
    styleUrls  : ['./profile-edit.component.scss']
})
export class ProfileEditComponent implements OnInit, OnDestroy
{

    regForm: FormGroup;
    regFormErrors: any;
    loading = false;
    user: User;
    private _unsubscribeAll: Subject<any>;
    constructor(private _router: Router, private _userProfile: UserProfileService,
        private _formBuilder: FormBuilder) {
            this._unsubscribeAll = new Subject();
        this.regFormErrors = {
            name: {},
            lastname: {},
            email : {},
            cellphone: {}
        };
        this.user = new User();
    }

    ngOnInit()
    {
        this.regForm = this._formBuilder.group({
            name: ['', Validators.required],
            lastname: ['', Validators.required],
            email : ['', [Validators.required, Validators.email]],
            cellphone: ['']
        });

        this.regForm.valueChanges.subscribe(() => {
            this.onregFormValuesChanged();
        });

        this._userProfile.userOnChanged.pipe(takeUntil(this._unsubscribeAll))
        .subscribe( user => {
                this.user = user;
                this.regForm.patchValue(this.user);
        });


    }
    onregFormValuesChanged()
    {
        for ( const field in this.regFormErrors )
        {
            if ( !this.regFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.regFormErrors[field] = {};

            // Get the control
            const control = this.regForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.regFormErrors[field] = control.errors;
            }
        }
    }


    onSubmit(){
        if (this.regForm.valid) {
            this.loading = true;
            const data = this.regForm.getRawValue();
            this._userProfile.update(data)
            .then((res: any) => {
                this.loading = false;
            }).catch ((err: any) => {
                this.loading = false;
            });

        }

    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}





